const classes_api = "https://ddt6tjz9bd.execute-api.ap-northeast-2.amazonaws.com/dev"

module.exports = { classes_api }